<template>
  <fieldset
    :class="show[name] ? 'indicate-border' : ''"
    class="container p4"
    :key="$store.state.counter"
    @change="$set(item, 'conditions', conditionals)"
  >
    <div v-if="$store.state.dev">Data: {{ data }}</div>
    <button
      type="button"
      class="align-center xs-font indicate-text"
      @click="
        conditions.length === 0 &&
          conditions.push({
            left: {type: 'value'},
            compare: '',
            right: {type: 'value'},
          });
        $set(show, name, !show[name]);
      "
    >
      <i
        :class="`r4 black-text fa-sm fa fa-${
          show[name] ? 'chevron-up' : 'chevron-down'
        }`"
      ></i
      ><i class="fa-sm fa fa-question"></i>
    </button>
    <div v-if="show[name]">
      <div
        v-for="(condition, conditioni) in conditionals"
        :key="'condition' + conditioni"
        class="flex align-center center"
      >
        <div class="b8 flexy sub-container" v-if="conditioni % 2 === 0">
          <div class="flex wrap align-center between">
            <row j="center" class="flexy">
              Left
              <select class="m8" v-model="condition.compare">
                <option
                  v-for="comparitor in comparitors"
                  :key="comparitor.type"
                  :value="comparitor.type"
                >
                  {{ comparitor.name }}
                </option>
              </select>
              Right
            </row>
            <rm
              class="l8"
              :obj="conditions"
              :name="
                conditions.length === 1
                  ? conditioni
                  : conditioni > 0
                  ? [conditioni, conditioni - 1]
                  : [conditioni, conditioni + 1]
              "
            ></rm>
          </div>
          <div class="flex between wrap">
            <div
              v-for="side in ['left', 'right']"
              :key="side + 'side'"
              class="flexy container p4 m4"
            >
              <b>{{ side.toUpperCase() }}</b>
              <row>
                Type: <select v-model="conditions[conditioni][side].type">
                  <option v-for="ctype in ['value', 'fn', 'state', 'local']" :key="conditioni+ctype+side" :value="ctype">{{ctype}}</option></select>
              </row>
              <row v-if="data && conditions[conditioni][side].type == 'local'">
                Local data:
                <state
                  :value="conditions[conditioni][side]"
                  v-model="conditions[conditioni][side]"
                  :statedata="data"
                  select="true"
                />
              </row>
              <row v-if="conditions[conditioni][side].type !== 'local' || !data " >
                {{conditions[conditioni][side].type && conditions[conditioni][side].type}}: <iinput stick :view="conditions[conditioni][side].type == 'value' ? 'input': conditions[conditioni][side].type || 'input'" v-model="conditions[conditioni][side].value" />
              </row>
            </div>
          </div>
        </div>
        <div v-if="conditioni % 2 !== 0">
          <select v-model="conditionals[conditioni]">
            <option
              v-for="operator in operators"
              :key="operator"
              :value="operator"
            >
              {{ operator }}
            </option>
          </select>
        </div>
      </div>

      <span class="flex align-center b8 center" v-if="conditionals.length > 0">
        <select
          @change="
            conditions.length !== 0 && conditions.length % 2 === 0
              ? (conditions.length = conditions.length - 1)
              : null;
            conditions[conditions.length] = selected.operator;
            conditions.push({
              left: {type: 'value'},
              compare: '',
              right: {type: 'value'},
            });
            $set(selected, 'operator', false);
          "
          v-model="selected.operator"
        >
          <option
            v-for="operator in operators"
            :key="operator"
            :value="operator"
          >
            {{ operator }}
          </option>
        </select>
      </span>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "if",
  computed: {
    conditionals() {
      const conditions = this.conditions;
      if (conditions.length !== 0 && conditions.length % 2 === 0) {
        conditions.length = conditions.length - 1;
      }
      this.$set(this.item, "conditions", conditions);
      return conditions;
    },
  },
  data() {
    return {
      // action function must parse the arrays and evaluate to T or F
      inputs: {},
      comparitors: [
        { name: "Equals", type: "==" },
        { name: "Does not equal", type: "!=" },
        { name: "Greater than", type: ">" },
        { name: "Greater than or equal", type: ">=" },
        { name: "Less than", type: "<" },
        { name: "Less Than or equal", type: "<=" },
        { name: "Includes", type: "includes" },
        { name: "Excludes", type: "excludes" },
      ],
      operators: ["&&", "||"],
      selected: {
        operator: false,
      },
      show: {},
    };
  },
  props: {
    item: {
      description: 'The item to conditionally check',
      type: Object,
      default: () => {},
    },
    data: {
      type: [Object, Array, String, Number, Boolean],
      default: () => {},
    },
    conditions: {
      type: Array,
      default: () => [], // [['x', '==', 'y'], '&&', ['z', '!=', 'a']]
    },
    name: {
      type: String,
      default: () => "conditional_" + Date.now(), // [['x', '==', 'y'], '&&', ['z', '!=', 'a']]
    },
  },
};
</script>
